import React, { useState, useEffect, useRef } from 'react';
import { Box, Tooltip, } from "@mui/material";
const EllipsisWithTooltip = ({ text, width }) => {
    const ref = useRef(null);
    const [isOverflowed, setIsOverflowed] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const check = () => {
            setIsOverflowed(el.scrollWidth > el.clientWidth);
        };

        check();
        window.addEventListener("resize", check);
        return () => window.removeEventListener("resize", check);
    }, [text]);

    const BoxText = (
        <Box
            ref={ref}
            sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: width || "100%",
                width: 'fit-content',
                display: "block",
                cursor: "default",
                display: 'inline-block',
                paddingRight: '4px'
            }}
        >
            {text}
        </Box>
    );

    return isOverflowed ? (
        <Tooltip
            arrow
            title={text}
            placement="top-start"
            slotProps={{
                tooltip: {
                    sx: {
                        maxWidth: 500,
                    },
                },
            }}
        >
            {BoxText}
        </Tooltip>
    ) : (
        BoxText
    );
};

export default EllipsisWithTooltip